import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../context/AuthContext";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import "../styles/Dashboard.css";

const statusLabels = {
  1: "Lucrari cu Probleme",
  2: "Lucrări Active",
  3: "Montaje Finalizate",
  4: "Dosare Prosumatori",
  5: "Certificate de Racordare",
};

const Dashboard = () => {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const [stats, setStats] = useState({});
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [statusLogs, setStatusLogs] = useState([]);
  const ITEMS_PER_PAGE = 10; // Definește numărul de elemente pe pagină
  const [currentPage, setCurrentPage] = useState(1); // Adaugă useState pentru paginare

  useEffect(() => {
    if (!user) {
      navigate("/login");
    }

    axios
      .get("https://casaverde.marenergy.ro/api.php?action=get_dashboard_stats")
      .then((response) => {
        if (response.data) {
          setStats(response.data);
        }
      })
      .catch((error) => {
        console.error("Eroare la încărcarea statisticilor:", error);
      });

    axios
      .get("https://casaverde.marenergy.ro/api.php?action=get_dashboard_messages")
      .then((response) => {
        if (response.data) {
          setMessages(response.data);
        }
      })
      .catch((error) => {
        console.error("Eroare la încărcarea mesajelor:", error);
      });

    axios
      .get("https://casaverde.marenergy.ro/api.php?action=get_status_logs")
      .then((response) => {
        if (response.data) {
          setStatusLogs(response.data);
        }
      })
      .catch((error) => {
        console.error("Eroare la încărcarea istoricului:", error);
      });
  }, [user, navigate]);

  const handleNavigateToClients = (status) => {
    navigate(`/clients?status=${status}`);
  };

  const handleAddMessage = () => {
    if (user.role !== "1") {
      alert("Nu aveti permisiunea de a adauga mesaje!");
      return;
    }

    if (newMessage.trim() === "") {
      alert("Introduceți un mesaj valid!");
      return;
    }

    axios
      .post("https://casaverde.marenergy.ro/api.php", {
        action: "add_dashboard_message",
        message: newMessage,
      })
      .then(() => {
        setMessages([{ message: newMessage, id: Date.now(), created_at: new Date().toISOString() }, ...messages]);
        setNewMessage("");
      })
      .catch(() => alert("Eroare la adăugarea mesajului"));
  };

  const handleDeleteMessage = (messageId) => {
    axios
      .post("https://casaverde.marenergy.ro/api.php", {
        action: "delete_dashboard_message",
        id: messageId,
      })
      .then(() => {
        setMessages(messages.filter((msg) => msg.id !== messageId));
      })
      .catch(() => alert("Eroare la ștergerea mesajului"));
  };

  const totalPages = Math.ceil(statusLogs.length / ITEMS_PER_PAGE);
  const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
  const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;
  const currentLogs = statusLogs.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <div className="container">
      <div className="user-info">
        <span className="user-name">👤 {user?.name || "Utilizator"}</span>
      </div>
      <div className="d-flex justify-content-between align-items-center my-4">
        <img src="/images/Logo.webp" alt="Logo" className="dashboard-logo" />
        <button className="btn btn-danger" onClick={logout}>
          Logout
        </button>
      </div>

      <div className="row">
        {Object.entries(statusLabels)
          .filter(([status]) => {
            if ((status === "4" || status === "5") && !(user.role === "1" || user.role === "2")) {
              return false;
            }
            return stats[status] > 0;
          })
          .map(([status, label]) => (
            <div className="col-md-4" key={status}>
              <div className={`stat-card ${parseInt(status, 10) === 1 ? "stat-card-red" : ""}`}>
                <div className="stat-icon">
                  {status === "1" && <i className="fas fa-exclamation-triangle"></i>}
                  {status === "2" && <i className="fas fa-tools"></i>}
                  {status === "3" && <i className="fas fa-check-circle"></i>}
                  {status === "4" && <i className="fas fa-file-contract"></i>}
                  {status === "5" && <i className="fas fa-folder-plus"></i>}
                </div>
                <div className="stat-content">
                  <h3>{label}</h3>
                  <p className="stat-number">{stats[status] || 0}</p>
                  <button className="btn btn-outline-primary mt-2" onClick={() => handleNavigateToClients(status)}>
                    Vezi proiectele
                  </button>
                </div>
              </div>
            </div>
          ))}
      </div>

      <div className="mt-5">
        <h2>📢 Mesaje Generale</h2>
        <div className="card p-4 shadow mt-3">
          <ul className="list-group">
            {messages.length > 0 ? (
              messages.map((msg) => (
                <li key={msg.id} className="list-group-item d-flex justify-content-between align-items-center">
                  <span>{msg.message}</span>
                {user.role === "1" && (  
                  <button className="btn btn-danger btn-sm" onClick={() => handleDeleteMessage(msg.id)}>
                    Șterge
                  </button>
                )}  
                </li>
              ))
            ) : (
              <p className="text-muted">Niciun mesaj disponibil</p>
            )}
          </ul>
          {user.role === "1" && (
            <div className="d-flex mt-3">
              <input
                type="text"
                className="form-control"
                placeholder="Adaugă un mesaj..."
                value={newMessage}
                onChange={(e) => setNewMessage(e.target.value)}
              />
              <button className="btn btn-primary ml-2" onClick={handleAddMessage}>
                Adaugă Mesaj
              </button>
            </div>
          )}
        </div>
      </div>

      <div className="mt-5">
        <h2>📜 Istoric Actualizări</h2>
        <div className="card p-4 shadow mt-3">
          <ul className="list-group">
            {currentLogs.length > 0 ? (
              currentLogs.map((log, index) => (
                <li key={index} className="list-group-item">
                  <strong>{new Date(log.updated_at).toLocaleString()} </strong>  
                  {log.user_name || "Necunoscut"} a actualizat statusul clientului{" "}

                  <Link 
                    to={`/clients/${log.client_id}`} 
                    style={{ textDecoration: "none", color: "inherit", fontWeight: "bold", cursor: "pointer" }}
                  >
                    {log.client_name}
                  </Link>

                  {" "}din{" "}
                  <Link 
                    to={`/clients?status=${log.old_status}`} 
                    style={{ textDecoration: "none", fontWeight: "bold", color: "inherit", cursor: "pointer" }} // Roșu pentru contrast
                  >
                    {statusLabels[log.old_status] || "Necunoscut"}
                  </Link>

                  {" "}in{" "}
                  <Link 
                    to={`/clients?status=${log.new_status}`} 
                    style={{ textDecoration: "none", fontWeight: "bold", color: "inherit", cursor: "pointer" }} // Verde pentru contrast
                  >
                    {statusLabels[log.new_status] || "Necunoscut"}
                  </Link>.
                </li>
              ))
            ) : (
              <p className="text-muted">Nicio modificare de status inregistrata.</p>
            )}
          </ul>

          {/* Butoane de paginare */}
          {totalPages > 1 && (
            <nav className="d-flex justify-content-center mt-3">
              <ul className="pagination">
                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                  <button className="page-link" onClick={() => setCurrentPage(currentPage - 1)}>Înapoi</button>
                </li>
                <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                  <button className="page-link" onClick={() => setCurrentPage(currentPage + 1)}>Înainte</button>
                </li>
              </ul>
            </nav>
          )}
        </div>
      </div>      
      <hr />    
    </div>
  );
};

export default Dashboard;